var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "multi-content" } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center p-3" },
        [
          _vm.loading
            ? _c("b-spinner", {
                staticStyle: { width: "2rem", height: "2rem" },
                attrs: { label: "Large Spinner", type: "grow" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          attrs: { card: "" },
          scopedSlots: _vm._u([
            {
              key: "tabs-end",
              fn: function () {
                return [
                  _c(
                    "b-nav-item",
                    {
                      attrs: { role: "presentation" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.showAddingNewLanguageSelectionForm()
                        },
                      },
                    },
                    [_c("b", [_vm._v("+")])]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.tabIndex,
            callback: function ($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex",
          },
        },
        _vm._l(_vm.systemLanguages, function (code) {
          return _c(
            "b-tab",
            { key: code, attrs: { title: !!code ? code.toUpperCase() : "" } },
            [
              _vm._l(_vm.content, function (c, i) {
                return _c(
                  "div",
                  { key: code + "-" + i, staticClass: "relative" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "exclusive-text-tool-class",
                        class: {
                          "exclusive-text-tool-hided-class":
                            _vm.hideTextCustomization,
                        },
                        attrs: { label: c.label },
                      },
                      [
                        _c(
                          "b-input-group",
                          {
                            staticClass: "position-relative translatable-area",
                          },
                          [
                            c.type === "input"
                              ? _c("b-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: c.validation,
                                      expression: "c.validation",
                                    },
                                  ],
                                  attrs: {
                                    name: c.label + "-" + code,
                                    placeholder: c.placeholder,
                                  },
                                  model: {
                                    value: _vm.content[i].data[code],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.content[i].data, code, $$v)
                                    },
                                    expression: "content[i].data[code]",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            c.type === "text"
                              ? _c("b-textarea", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: c.validation,
                                      expression: "c.validation",
                                    },
                                  ],
                                  attrs: {
                                    name: c.label + "-" + code,
                                    placeholder: c.placeholder,
                                  },
                                  model: {
                                    value: _vm.content[i].data[code],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.content[i].data, code, $$v)
                                    },
                                    expression: "content[i].data[code]",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            c.type === "rich"
                              ? _c("wysiwyg", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: c.validation,
                                      expression: "c.validation",
                                    },
                                  ],
                                  attrs: {
                                    name: c.label + "-" + code,
                                    placeholder: c.placeholder,
                                  },
                                  model: {
                                    value: _vm.content[i].data[code],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.content[i].data, code, $$v)
                                    },
                                    expression: "content[i].data[code]",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "translate-toolbox" }, [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{ followCursor: true, placement: 'bottom-end' }",
                                    },
                                  ],
                                  staticClass: "translate-btn mr-1",
                                  attrs: {
                                    content: _vm.$t(
                                      "message.vtippyTranslateButton"
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.translate(i, code)
                                    },
                                  },
                                },
                                [_c("md-icon", [_vm._v("translate")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{ followCursor: true, placement: 'bottom-end' }",
                                    },
                                  ],
                                  staticClass: "translate-btn bg-danger",
                                  attrs: {
                                    content: _vm.$t(
                                      "message.vtippyTranslateClearButton"
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.clearContents(i, code)
                                    },
                                  },
                                },
                                [_c("md-icon", [_vm._v("clear")])],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.systemLanguages.length > 1
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "delete-lang-button",
                      attrs: {
                        content: _vm.$t("message.deleteSystemLanguage", {
                          code: code,
                        }),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showDeleteModal(code)
                        },
                      },
                    },
                    [
                      _c(
                        "md-icon",
                        { staticClass: "delete-icon", attrs: { color: "red" } },
                        [_vm._v("delete")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "lang-form",
                title: _vm.$t("message.selectALanguage"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "b-form",
                {
                  staticClass: "d-flex flex-column justify-content-center",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.addLang.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: _vm.$t("message.language") } },
                            [
                              _c(
                                "b-form-select",
                                {
                                  model: {
                                    value: _vm.lang,
                                    callback: function ($$v) {
                                      _vm.lang = $$v
                                    },
                                    expression: "lang",
                                  },
                                },
                                _vm._l(_vm.filteredLanguages, function (l) {
                                  return _c(
                                    "option",
                                    {
                                      key: l.code,
                                      domProps: { value: l.code },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(l.label) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary",
                                disabled: typeof _vm.lang !== "string",
                              },
                            },
                            [
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.save")) +
                                    "\n                        "
                                ),
                              ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("b-button", { on: { click: _vm.hideModal } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.cancel")) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }